import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import 'react-toastify/dist/ReactToastify.css';

// Konfiguration
import { msalConfig } from './auth/authConfig';

// Pages
import Home from './pages/Home';
import LabDay from './pages/LabDay';
import Voting from './pages/Voting';
import Archive from './pages/Archive';
import Login from './pages/Login';
import NewLabDay from './pages/NewLabDay';

// Components
import Navigation from './components/Navigation';
import ProtectedRoute from './auth/ProtectedRoute';
import AuthRedirectHandler from './components/AuthRedirectHandler';

// Initialisiere MSAL
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthRedirectHandler />
      <div className="min-h-screen bg-shopware-grey font-inter">
        <Navigation />
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route 
              path="/lab/new" 
              element={
                <ProtectedRoute>
                  <NewLabDay />
                </ProtectedRoute>
              } 
            />
            <Route path="/lab/:slug" element={<LabDay />} />
            <Route path="/lab/:slug/vote" element={<Voting />} />
            <Route path="/login" element={<Login />} />
            <Route 
              path="/labdays" 
              element={
                <ProtectedRoute>
                  <Archive />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </main>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </MsalProvider>
  );
}

export default App; 